import React from "react";

function ComingSoonAdmin({ title, subtitle }) {
  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950">
      <div className="pt-6 md:ml-64 p-4">
        <div className="mx-auto max-w-7xl">
          <section className="rounded-2xl border border-black/5 dark:border-white/10 bg-white dark:bg-slate-900 shadow-sm p-6">
            <div className="inline-flex items-center gap-2 rounded-full border border-black/10 dark:border-white/10 bg-slate-50 dark:bg-white/5 px-3 py-1 text-xs text-slate-600 dark:text-slate-300">
              <span aria-hidden>⏳</span> Coming soon
            </div>

            <h1 className="mt-4 text-xl sm:text-2xl font-semibold tracking-tight text-slate-900 dark:text-white">
              {title}
            </h1>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-300">{subtitle}</p>

            <div className="mt-5 rounded-2xl border border-dashed border-black/10 dark:border-white/10 p-5 text-sm text-slate-500 dark:text-slate-400">
              Cette section sera disponible dans une prochaine mise à jour.
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default function ReviewsPage() {
  return (
    <ComingSoonAdmin
      title="Reviews"
      subtitle="Gestion des avis / retours utilisateurs et modération."
    />
  );
}
